import React from "react";

// --- Styles ---
const chatRow = { 
  display: "flex", 
  margin: "8px 0",
  padding: "0 4px",
  transition: "all 0.2s ease",
};

const chatRowSent = { justifyContent: "flex-end" };
const chatRowReceived = { justifyContent: "flex-start" };

const chatBubbleBase = {
  padding: "12px 16px",
  borderRadius: "18px",
  position: "relative",
  wordWrap: "break-word",
  fontSize: "15px",
  lineHeight: "1.5",
  color: "#1a1a1a",
  fontWeight: "400",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  transition: "all 0.2s ease",
  maxWidth: "75%",
};

const chatBubbleSent = {
  ...chatBubbleBase,
  maxWidth: "65%",
  backgroundColor: "#ffffff",
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "18px",
  borderBottomLeftRadius: "18px",
  borderTopLeftRadius: "18px",
  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)",
  border: "1px solid rgba(0, 0, 0, 0.05)",
};

const chatBubbleReceived = {
  ...chatBubbleBase,
  maxWidth: "85%",
  backgroundColor: "#e3f2fd",
  borderTopLeftRadius: "4px",
  borderBottomRightRadius: "18px",
  borderBottomLeftRadius: "18px",
  borderTopRightRadius: "18px",
  boxShadow: "0 2px 12px rgba(22, 114, 222, 0.15), 0 1px 3px rgba(22, 114, 222, 0.1)",
  border: "1px solid rgba(22, 114, 222, 0.12)",
  color: "#1a1a1a",
};

const chatTime = {
  display: "flex",
  justifyContent: "flex-end",
  fontSize: "11px",
  marginTop: "6px",
  color: "#6b7280",
  fontWeight: "400",
  letterSpacing: "0.2px",
  opacity: 0.75,
};

// --- Component ---
export default function ChatMessage({ message, isSender }) {
  const formattedResponse =
    typeof message.text === "string"
      ? message.text.split("\n").map((line, i) => (
          <span key={i}>
            {line}
            <br />
          </span>
        ))
      : message.text; // in case of highlighted JSX

  return (
    <div style={{ ...chatRow, ...(isSender ? chatRowSent : chatRowReceived) }}>
      <div style={isSender ? chatBubbleSent : chatBubbleReceived}>
        <div>{formattedResponse}</div>
        <div style={chatTime}>{message.formattedTime}</div>
      </div>
    </div>
  );
}
